import { OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { STATUS_APPROVALS } from '@consts';
import { EquipmentsApi } from '@core/api/equipments/equipments.api';
import { clearEmptyProperties, mapCheckbox } from '@core/utils/filters-utils';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import * as _ from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';
import english from '../i18n/en.json';
import spanish from '../i18n/es.json';
import portuguese from '../i18n/pt.json';
var FilterApprovalsEquipmentsComponent = /** @class */ (function () {
    function FilterApprovalsEquipmentsComponent(formBuilder, fuseTranslationLoaderService, equipmentsApi) {
        this.formBuilder = formBuilder;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.equipmentsApi = equipmentsApi;
        this.filterChanged = new BehaviorSubject({ status_in: ['pending'] });
        this.types = [];
        this.locations = [];
        this.STATUS = STATUS_APPROVALS;
        this.companies = [];
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    Object.defineProperty(FilterApprovalsEquipmentsComponent.prototype, "status", {
        get: function () {
            return this.filtersForm.get('status');
        },
        enumerable: true,
        configurable: true
    });
    FilterApprovalsEquipmentsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.equipmentsApi.getFiltersData().subscribe(function (result) {
            _this.types = _.clone(result['equipmentsTypes']['items']);
            _this.locations = _.clone(result['locations']['items']);
            _this.companies = _.clone(result['companies']['items']);
        });
        this.filtersForm = this.formBuilder.group({
            status: this.formBuilder.array(STATUS_APPROVALS.map(function (situation) {
                if (situation.name === 'pending') {
                    return _this.formBuilder.control(true);
                }
                return _this.formBuilder.control(false);
            })),
            number: null,
            name: null,
            typeId: null,
            locationId: null,
            companies: new FormControl([])
        });
        this.filtersForm.valueChanges.pipe(debounceTime(500), tap(function () {
            var filters = clearEmptyProperties({
                name_contains: _this.filtersForm.value.name,
                number_contains: _this.filtersForm.value.number,
                equipmentType_in: _this.filtersForm.value.typeId,
                location_in: _this.filtersForm.value.locationId,
                company_in: _this.filtersForm.value.companies,
                status_in: _this.getStatus()
            });
            _this.filterChanged.next(filters);
        })).subscribe();
    };
    FilterApprovalsEquipmentsComponent.prototype.getStatus = function () {
        var name = mapCheckbox(this.filtersForm.value.status, STATUS_APPROVALS, 'name');
        if (name) {
            return name;
        }
        return null;
    };
    FilterApprovalsEquipmentsComponent.prototype.getPropertyValue = function (value, array, property) {
        var item = _.find(array, function (a) { return a.id === value; });
        return item[property];
    };
    FilterApprovalsEquipmentsComponent.prototype.clearFilters = function () {
        this.filtersForm.patchValue({
            number: null,
            name: null,
            typeId: null,
            locationId: null,
            companies: null,
            status: STATUS_APPROVALS.map(function (status) {
                return status.name === 'pending';
            }),
        });
    };
    return FilterApprovalsEquipmentsComponent;
}());
export { FilterApprovalsEquipmentsComponent };
